export class CorreiosService {
  /**
   * @param {*} CorreiosResource
   */
  constructor(CorreiosResource) {
    this.resource = CorreiosResource;
  }

  async saveReverse(reverse) {
    return this.resource.saveReverse(reverse).$promise;
  }

  async getReverseDeliveryTypes(sender, recipientAddress) {
    return this.resource.getReverseDeliveryTypes({
      cepRemetente: sender.endereco.codigoPostal,
      cepDestinatario: recipientAddress.codigoPostal,
    })
    .$promise;
  }
}
